<template>
    <span>
        <a class="open_btn" @click="showPreviewInfo()" style="margin: 0 12px;">访问记录</a>
        <a-modal :visible="visible" :loading="loading" :destroyOnClose="true" :width="1200" title="预习任务分析"
            @ok="visible = false;" @cancel="visible = false;">
            <template v-if="data.length == 0">
                <a-empty />
            </template>
            <template v-else>
                <a-timeline mode="alternate" :reverse="reverse">
                    <a-timeline-item v-for="(item, index) in data" :key="index">
                        <a-icon slot="dot" type="clock-circle-o" style="font-size: 16px;" />
                        <p>{{ item.create_time }}</p>
                        <p>{{ item.name }} — {{ item.title }}</p>
                        <p v-if="item.chapter_name">章节信息：{{ item.chapter_name }}</p>
                        <p v-if="item.browsing_time">访问时长：{{ dateFormate(item.browsing_time) }}</p>
                    </a-timeline-item>
                </a-timeline>
                <div style="text-align: center;">
                    <a-button type="primary" style="margin-top: 16px" @click="loadMore" :disabled="notMore">
                        {{ notMore ? '没有更多了' : '加载更多' }}
                    </a-button>
                </div>
            </template>
        </a-modal>
    </span>
</template>

<script>
export default {
    props: ['id'],
    data() {
        return {
            visible: false,
            loading: false,
            data: [],
            reverse: false,
            pageinfo: {
                total: 1,
                current: 1,
                pageSize: 10
            },
            notMore: false
        }
    },
    methods: {
        showPreviewInfo() {
            this.visible = true;
            this.getData()
        },
        loadMore() {
            this.pageinfo.current = this.pageinfo.current + 1;
            this.getData()
        },
        getData() {
            this.$axios.post('/api/AccessLog/listbyadmin', {
                data: {
                    admin_id: this.id
                },
                pageinfo: this.pageinfo
            }).then(res => {
                if (res.data.data.length > 0) {
                    if (this.pageinfo.current == 1) {
                        this.data = res.data.data
                    } else {
                        this.data = this.data.concat(res.data.data);
                    }
                    this.pageinfo = res.data.pageinfo;
                } else {
                    this.notMore = true
                }
            }).catch(error => {
                console.log(error);
            })
        },
        dateFormate(number) {
            let time = Number(number)
            if (time < 60) {
                return time + '秒'
            } else if (time >= 60 && time < 3600) {
                return parseInt(time / 60) + '分' + time % 60 + '秒'
            } else if (time >= 3600 && time < 86400) {
                return parseInt(time / 3600) + '时' + parseInt((time % 3600) / 60) + '分' + time % 60 + '秒'
            } else {
                return parseInt(time / 86400) + '天' + parseInt((time % 86400) / 3600) + '时' + parseInt((time % 86400) / 60) + '分' + time % 60 + '秒'
            }
        },
    }
}
</script>

<style lang="less" scoped></style>